import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RequestTypeEnum } from "src/components/Changes/types";
import { DraftsTableRow } from "../types";

export const useDraftsNavigation = (row: DraftsTableRow) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleOnClick = useCallback(() => {
    if (RequestTypeEnum.CHANGE_SUPPLY === row.requestType) {
      navigate(`/change-request/${row.id}`, {
        state: {
          serviceType: row.serviceType,
          backUrl: location.pathname + location.search,
        },
      });
    } else {
      navigate(`/new-premise/${row.id}?connection=${row.connectionType}`, {
        state: {
          serviceType: row.serviceType,
          backUrl: location.pathname + location.search,
        },
      });
    }
  }, [navigate, location.pathname, location.search, row]);
  return { handleOnClick, navigate, location };
};
